














































import { Component, Mixins } from 'vue-property-decorator';
import { MUTATE_SHOW_UPGRADE_PLAN, MUTATE_SHOW_VERIFY_EMAIL } from '@/store/modules/interface';
import HomeMixins from '@/mixins/vue/HomeMixins';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import Navigation from '@/components/home/Navigation.vue';
import { OrderItemPayload } from '@luxtag/papybase';
import OrderMixin from '@/mixins/vue/OrderMixin';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import UpgradePlanDialog from '@/components/global/UpgradePlanDialog.vue';
import VerifyEmailDialog from '@/components/global/VerifyEmailDialog.vue';
import { order } from '@/plugins/papybase/papybaseInit';

@Component({
    components: {
        Navigation,
        VerifyEmailDialog,
        UpgradePlanDialog,
        SimpleDialog,
    },
})
export default class Home extends Mixins(HomeMixins, IsMobileMixin, OrderMixin) {
    public showWelcomeMessageDialog = false;

    public showTutorialHintDialog = false;

    public created() {
        this.integrateTemplateListFromBackEndToLocalStorage().catch((error) => {
            console.error(error);
        });

        this.integratePhotoListFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateActivitesFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateTotalActivitesDailyFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateTotalActivitesMonthlyFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateTotalActivitesYearlyFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateProductListFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateBalanceFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateOrdersFromBackEndToLocalStorage().then(() => {
            this.initShowWelcomeMessageDialog();
        }).catch((err: any) => {
            console.error(err);
        });
    }

    public initShowWelcomeMessageDialog() {
        if (this.orders.length > 0) return;
        this.showWelcomeMessageDialog = true;
    }

    public welcomeMessageDialogActionClick(isPositive: boolean) {
        if (isPositive) {
            this.requestXEM();
            this.showTutorialHintDialog = true;
        }
    }

    public requestXEM() {
        const orderXemPayload: OrderItemPayload[] = [
            {
                product_id: 2,
                cert_id: null as any,
                qty: 1,
            },
        ];

        order.createOrder(this.jwt, orderXemPayload).catch((err: any) => {
            console.error(err);
        });
    }

    get orders() {
        return this.$store.getters.getOrders;
    }

    get showUpgradePlan() {
        return this.$store.getters.getShowUpgradePlan;
    }

    set showUpgradePlan(val) {
        this.$store.commit(MUTATE_SHOW_UPGRADE_PLAN, false);
    }

    get showVerifyEmail() {
        return this.$store.getters.getShowVerifyEmail;
    }

    set showVerifyEmail(val) {
        this.$store.commit(MUTATE_SHOW_VERIFY_EMAIL, false);
    }
}
